import { memo } from 'react'

import { ConcernLevelBlockProps, Level } from './types'

const STYLES: Record<number, { gauge: string; pin: string; color: string }> = {
  [Level.One]: {
    gauge:
      'M21.6412 118.586C18.897 131.859 18.3477 145.486 20.0101 158.926C20.1668 160.192 21.3389 161.07 22.6019 160.89L24.1678 160.667C25.4308 160.486 26.3062 159.317 26.1509 158.05C24.5888 145.319 25.1153 132.413 27.7145 119.842L21.6412 118.586Z',
    pin: 'M10.6399 136.658C11.2984 137.056 11.2784 138.019 10.6039 138.389L4.53333 141.728C3.85882 142.099 3.03565 141.601 3.05162 140.831L3.1954 133.905C3.21138 133.135 4.05452 132.671 4.71305 133.07L10.6399 136.658Z',
    color: '#01A473',
  },
  [Level.Two]: {
    gauge:
      'M37.1665 79.1968C29.7176 91.4309 24.4441 104.863 21.5798 118.897L27.6563 120.137C30.3774 106.805 35.3872 94.0444 42.4637 82.422L37.1665 79.1968Z',
    pin: 'M18.1961 93.3454C18.6411 93.9736 18.2392 94.8479 17.4727 94.9192L10.5743 95.5609C9.80778 95.6322 9.25154 94.847 9.57304 94.1476L12.4665 87.8525C12.788 87.1531 13.7461 87.0639 14.1911 87.6921L18.1961 93.3454Z',
    color: '#01A473',
  },
  [Level.Three]: {
    gauge:
      'M64.9224 47.4107C53.8029 56.4394 44.3313 67.3258 36.9275 79.5874L42.2364 82.793C49.27 71.1446 58.2681 60.8025 68.8317 52.2252L64.9224 47.4107Z',
    pin: 'M42.6794 53.9227C42.9205 54.6537 42.2798 55.3717 41.5262 55.215L34.743 53.8048C33.9893 53.6481 33.6879 52.7343 34.2004 52.1599L38.8133 46.9906C39.3258 46.4163 40.2679 46.6121 40.5091 47.3432L42.6794 53.9227Z',
    color: '#74B816',
  },
  [Level.Four]: {
    gauge:
      'M101.708 26.7791C88.2055 31.5599 75.6336 38.6433 64.5493 47.7152L68.4772 52.5144C79.0073 43.8962 90.9506 37.167 103.778 32.6252L101.708 26.7791Z',
    pin: 'M76.7453 27.3566C76.7453 28.1264 75.9119 28.6075 75.2453 28.2226L69.2453 24.7585C68.5786 24.3736 68.5786 23.4114 69.2453 23.0265L75.2453 19.5624C75.9119 19.1775 76.7453 19.6586 76.7453 20.4284L76.7453 27.3566Z',
    color: '#F79009',
  },
  [Level.Five]: {
    gauge:
      'M143.514 19.6668C129.19 19.6199 114.967 22.0543 101.475 26.8621L103.556 32.704C116.374 28.1367 129.886 25.8239 143.494 25.8685L143.514 19.6668Z',
    pin: 'M118.944 13.3393C119.438 13.9303 120.386 13.7657 120.651 13.043L123.037 6.53884C123.303 5.81616 122.686 5.07742 121.928 5.2091L115.101 6.39429C114.343 6.52598 114.012 7.42933 114.505 8.02033L118.944 13.3393Z',
    color: '#F79009',
  },
  [Level.Six]: {
    gauge:
      'M185.323 27.0715C171.855 22.1963 157.644 19.6908 143.321 19.6661L143.31 25.8679C156.917 25.8913 170.418 28.2715 183.213 32.9029L185.323 27.0715Z',
    pin: 'M167.056 13.3393C166.562 13.9303 165.614 13.7657 165.349 13.043L162.963 6.53884C162.697 5.81616 163.314 5.07742 164.072 5.2091L170.899 6.39429C171.657 6.52598 171.988 7.42933 171.495 8.02033L167.056 13.3393Z',
    color: '#F79009',
  },
  [Level.Seven]: {
    gauge:
      'M221.977 47.9716C210.922 38.8637 198.373 31.7394 184.887 26.9147L182.798 32.754C195.61 37.3375 207.531 44.1056 218.033 52.7581L221.977 47.9716Z',
    pin: 'M209.357 30.219C208.7 30.6208 207.855 30.1611 207.835 29.3915L207.659 22.4656C207.639 21.696 208.46 21.1938 209.136 21.5616L215.222 24.8715C215.899 25.2393 215.923 26.2012 215.267 26.603L209.357 30.219Z',
    color: '#EC372C',
  },
  [Level.Eight]: {
    gauge:
      'M249.442 79.8399C242.068 67.5608 232.622 56.6519 221.524 47.5968L217.603 52.402C228.146 61.0043 237.12 71.3679 244.126 83.033L249.442 79.8399Z',
    pin: 'M243.914 58.5001C243.14 58.713 242.443 57.9727 242.702 57.2128L244.845 50.936C245.089 50.2229 246.003 50.025 246.52 50.5737L250.772 55.0923C251.289 55.6411 251.036 56.5422 250.309 56.7419L243.914 58.5001Z',
    color: '#EC372C',
  },
  [Level.Nine]: {
    gauge:
      'M264.685 119.128C261.848 105.088 256.6 91.6461 249.174 79.3978L243.871 82.613C250.925 94.2489 255.911 107.019 258.607 120.356L264.685 119.128Z',
    pin: 'M265.915 95.0058C265.152 94.9037 264.785 94.0139 265.255 93.4042L269.485 87.9166C269.954 87.3069 270.908 87.4345 271.201 88.1463L273.839 94.5527C274.132 95.2645 273.545 96.0267 272.782 95.9246L265.915 95.0058Z',
    color: '#EC372C',
  },
  [Level.Ten]: {
    gauge:
      'M263.574 161.169C264.836 161.353 266.01 160.478 266.17 159.212C267.863 145.775 267.346 132.147 264.632 118.868L258.556 120.11C261.126 132.687 261.623 145.594 260.031 158.322C259.873 159.588 260.746 160.759 262.008 160.942L263.574 161.169Z',
    pin: 'M274.51 141.086C273.828 140.728 273.789 139.767 274.439 139.355L280.293 135.649C280.943 135.237 281.795 135.684 281.827 136.453L282.11 143.375C282.141 144.144 281.328 144.659 280.646 144.302L274.51 141.086Z',
    color: '#875BF7',
  },
}
interface ConcernLabelProps {
  text: string
  color: string
}

const ConcernLabel = ({ text, color }: ConcernLabelProps) => {
  return (
    <div className="rounded-2xl py-1 px-[10px]" style={{ backgroundColor: color }}>
      <p className="text-label-2 text-white">{text}</p>
    </div>
  )
}

const ConcernLevelBlock = ({ ...props }: Readonly<ConcernLevelBlockProps>) => {
  const { concern_lv, concern_lv_expression, concern_lv_description, pet } = props

  if (!concern_lv || !concern_lv_expression || !concern_lv_description) {
    return null
  }

  return (
    <div className="dark:bg-gray-900 rounded-2xl bg-gray-50">
      <div className="relative flex flex-col items-center">
        <svg width="286" height="163" viewBox="0 0 286 163">
          {Object.values(STYLES).map(({ gauge, color }) => (
            <path
              d={gauge}
              style={{
                fill: color,
              }}
              key={gauge}
            />
          ))}
          <path
            d={STYLES[concern_lv].pin}
            style={{
              fill: STYLES[concern_lv].color,
            }}
          />
        </svg>
        {/* 라벨·단계만 게이지 안쪽(반원의 빈 가운데)에 둔다. 표현은 게이지 아래 흐름으로 쌓아 두 줄이 돼도 겹치지 않게 */}
        <div className="absolute bottom-0 left-0 right-0 flex h-20 flex-col items-center justify-center">
          <ConcernLabel text={`Level ${concern_lv}`} color={STYLES[concern_lv].color} />
          <div className="mt-1 text-gray-500 text-body-3">Out of level {Level.Ten}</div>
        </div>
      </div>
      <div className="mt-2 break-words px-4 text-center">
        <div className="text-gray-900 text-headline-3 dark:text-white">{concern_lv_expression}</div>
        <div className="text-gray-700 text-body-2">for {pet.name || 'pet'}'s issues</div>
      </div>
      <div className="mt-1 p-4 pb-3">
        <div className="text-gray-900 text-body-2 dark:text-gray-500">{concern_lv_description}</div>
      </div>
    </div>
  )
}

export default memo(ConcernLevelBlock)
